import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';
import { PermissionUrl } from "../urls/permission.url";
import { AppConstants } from "../constants/constants";
import { AccessUrl } from "../constants/permission";

@Injectable()
export class PermissionService {
  private token: string;
  private permissionOnPage: string[] = [];

  constructor() {
    this.token = localStorage.getItem(AppConstants.localStorage.token);
    let permission = localStorage.getItem(AppConstants.localStorage.permissionOnPage);
    this.permissionOnPage = (permission) ? permission.split(',') : [];
  }

  public getUserType() {
    return parseInt(localStorage.getItem(AppConstants.localStorage.userType));
  }

  public hasPermissionOnUrl(url: string) {
    const access = AccessUrl.filter(a => a.url === url);
    if (access.length > 0) {
      return (this.permissionOnPage.indexOf(access[0].permission) >= 0);
    }
    return false;
  }

  public getPermissionOnPage() {
    return this.permissionOnPage;
  }

  public setPermissionOnPage(permission) {
    return this.permissionOnPage = permission;
  }

  public hasPermissionOnPage(page: string) {
    return (this.permissionOnPage.indexOf(page) >= 0);
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/services/permission.service.ts